module.exports = __webpack_public_path__ + "static/media/3788.73283d82.jpg";